export { View as LoanFormCard } from './view'
